<template>
  <div class="content">
    <div class="content-box">
        <img class="imgStyle" src="@/assets/images/successfulPop.png" alt="">
        <div class="textStyle">
          {{ $t('seller.brandsPage.commissionSettingsComplete') }}
        </div>
         <artmisads-button type="primary" @click="handleClick">
           {{ $t('seller.brandsPage.viewDetailsPage') }}
         </artmisads-button>
    </div>
  </div>
</template>
<script setup >
import { ref, defineEmits } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const emit = defineEmits(['confirm'])
const handleClick = () => {
 let publisherDetail = JSON.parse(sessionStorage.getItem('brandDetail'))
  emit('confirm')
  //  window.open(`/seller/brand/detail/${publisherDetail.id}`, '_blank')
   router.push({
    path: `/seller/brand/detail/${publisherDetail.id}`,
  })
}
</script>
<style scoped lang="less">
.content{
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 570px;
  min-height: 400px;
  .content-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .imgStyle{
    width: 216px;
  }
  .textStyle{
    font-family: Sora;
font-weight: 500;
font-style: Medium;
font-size: 16px;
color: rgba(15, 6, 41, 1);
margin-bottom: 16px;
  }
}
</style>